import env from "env";

const ONESIGNAL_APP_ID = window.ONESIGNAL_APP_ID || env.ONESIGNAL_APP_ID || "";

const addScript = () => {
    return new Promise((resolve) => {
        window.OneSignal = window.OneSignal || [];
        if (!document.querySelector("#onesignal_sdk")) {
            let script = document.createElement("script");
            script.id = "onesignal_sdk";
            script.src = "https://cdn.onesignal.com/sdks/OneSignalSDK.js";
            document.head.appendChild(script);
        }
        window.OneSignal.push(function () {
            resolve(window.OneSignal)
        });
    })
}

export default {
    ready() {
        return addScript().then((OneSignal) => {
            if (!window._oneSignal_ready) {
                if (env.IS_DEVELOPMENT) {
                    OneSignal.log.setLevel('trace');
                }

                OneSignal.init({
                    appId: ONESIGNAL_APP_ID,
                    notifyButton: {
                        enable: false,
                    },
                });
                window._oneSignal_ready = true;
            }

            return Promise.resolve(OneSignal);
        })
    },
}
